import Script from 'next/script';

import { Skeleton } from '@common/atoms/Skeleton';
import { EmbedConsentGuard } from '@web/atoms/EmbedConsentGuard';
import { useEmbedConsented } from '@web/hooks/useEmbedConsented';

import styles from './ViaplayVideo.module.scss';

interface Props {
    videoID: string;
}

export const ViaplayVideo = ({ videoID }: Props) => {
    const { consented, loadingConsent } = useEmbedConsented('viaplay');

    return (
        <div className={styles['viaplay-video']}>
            {loadingConsent ? <Skeleton /> : null}

            {!consented && !loadingConsent ? <EmbedConsentGuard vendor="viaplay" /> : null}

            {consented ? (
                <div className={styles['frame']} id={videoID}>
                    <div className="ndm-load-via-play" data-tag={videoID}></div>
                    <Script
                        id={`${videoID}-script`}
                        src="https://ads.nextday.media/lib/viaplay-player/0001/cache-10/via.js"
                    />
                </div>
            ) : null}
        </div>
    );
};
